import { Flex } from '@chakra-ui/react'
import styled from 'styled-components'
import { colors } from '../../../ui-kit'

const MainContent = styled(Flex)`
  min-height: 100vh;
  max-height: 100vh;
  box-shadow: -3px 0 10px 0 rgba(0, 0, 0, 0.16);
  background-color: ${colors.appWhite};
  overflow: auto;
  flex-direction: column;
`

export const MainContentV2 = styled(Flex)`
  min-height: 100vh;
  max-height: 100vh;
  box-shadow: -3px 0 10px 0 rgba(0, 0, 0, 0.16);
  background-color: ${colors.appWhite};
  overflow: hidden;
  flex-direction: column;
`

export const MainContentHeadingBox = styled(Flex)<{ reverse?: boolean }>`
  width: 100%;
  padding: 1.5rem 1.5rem;
  flex-direction: ${props => (props.reverse ? 'row-reverse' : 'row')};
  border-bottom: 1px solid ${colors.appPaleLilac};
  justify-content: space-between;
  align-items: center;
  position: sticky;
  min-height: calc(3rem + 2.5 * var(--chakra-fontSizes-xl));
  max-height: calc(3rem + 2.5 * var(--chakra-fontSizes-xl));
  top: 0;
  z-index: calc(var(--chakra-zIndices-docked));
  background: white;
`

export const MainContentWrapper = styled(Flex)`
  padding: 1.5rem 1.5rem;
  flex-direction: column;
`

export const ContentWrapper = styled(Flex)`
  padding: 1.5rem 0;
  flex-direction: column;
`

export default MainContent
